import { Theme } from '@mui/material/styles'
import { palette, spacing } from 'c1ui'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const styles: moduleStyleType = {
    container: {
        border: `1px solid ${palette.border.primary}`,
        m: 0,
        mt: 3,
        borderRadius: C1BorderRadius.large,
        '& .MuiTable-root': {
            borderCollapse: 'collapse',
        },
        '& .MuiTableHead-root': {
            position: 'relative',
            border: 'none',
        },
        '& .MuiTableHead-root:before': {
            content: '""',
            position: 'absolute',
            height: '1px',
            left: '0',
            right: '0',
            bottom: '-1px',
        },
        '& .MuiTableHead-root:after': {
            content: '""',
            position: 'absolute',
            height: '1px',
            left: '0',
            right: '0',
            bottom: '0',
        },
    },
    underline: {
        pt: 1,
    },
    simpleTitle: {
        pt: 1,
        mb: 1,
    },
    margin: {
        mb: 3,
    },
    listContents: {
        width: '100%',
    },
    boxListContents: {
        width: '100%',
        m: 1,
    },
    header: {
        '& .MuiTableCell-stickyHeader': {
            background: palette.grey[50],
            backgroundClip: 'padding-box',
            borderBottom: `1px solid ${palette.border.primary}`,
            p: (theme: Theme): string => theme.spacing(1, '3px'),
        },
        '& .MuiTableCell-stickyHeader:first-child': {
            pl: 3,
        },
        '& .MuiTableCell-stickyHeader:last-child': {
            pr: 3,
        },
    },
    row: {
        border: 0,
        '& .MuiTableRow-root': {
            backgroundColor: palette.grey[50],
            borderBottom: `1px solid ${palette.border.subtle}`,
            '&:hover': {
                backgroundColor: palette.grey[50],
            },
            '&:nth-of-type(odd)': {
                backgroundColor: palette.background.default,
                '&:hover': {
                    backgroundColor: palette.background.default,
                },
            },
        },
        '& .MuiTableRow-root:last-child': {
            borderBottom: 'none',
        },
        '& .MuiTableCell-root': {
            p: 1,
            border: 0,
        },
        '& .MuiTableCell-root:first-child': {
            pl: 3,
        },
        '& .MuiTableCell-root:last-child': {
            pr: 3,
        },
    },
    button: {
        ml: 1,
    },
    questionMark: {
        fontSize: '10pt',
        fill: palette.grey[800],
        cursor: 'pointer',
        verticalAlign: 'middle',
        marginLeft: spacing.xs,
        marginBottom: '2px',
    },
    additionalInfo: {
        mb: 1,
        ml: 2,
    },
    searchContainer: {
        display: 'flex',
        alignItems: 'center',
        m: 0,
        borderWidth: '1px',
        borderRadius: C1BorderRadius.large,
        backgroundColor: 'grey.50',
    },
    buttonContainer: {
        marginLeft: 'auto',
        mt: 1,
        mr: 0,
        mb: 0,
        ml: 0,
    },
    simple: {
        pl: 0,
        pt: '10px',
    },
}

export const TableHeaderStyles: moduleStyleType = {
    margin1: {
        marginLeft: 1,
    },
    margin2: {
        marginLeft: 1,
    },
}
